import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const successStatusCode = 200;

export default {
    getCompanyContacts() {
        return Axios.get(`${baseURL}account/contacts/`).then(
            response => response.data.response
        );
    },
    checkBillingLock(params) {
        let sendDate = params.date ? `?date=${params.date}` : "";
        return Axios.get(
            `${baseURL}account/setting/check-billing-lock${sendDate}`
        ).then(response => response.data.response);
    },
    unlockBillingLock(password) {
        return Axios.post(`${baseURL}account/setting/unlock-billing-lock`, {
            password: password
        }).then(response => response.data.response);
    },
    /**
     * To check the beta release that set in dolittle
     * @param {String} key
     * @returns {Boolean}
     */
    checkFeature(key) {
        return Axios.get(
            `${baseURL}account/is-feature-enabled?key=${key}`
        ).then(response => response.data.response);
    },
    checkExtensionsEnabled(key) {
        return Axios.get(`${baseURL}account/extension/${key}`).then(
            response => response.data.response
        );
    },
    checkFeatureEnabled(key) {
        return Axios.get(`${baseURL}account/feature-status/${key}`).then(
            response => response.data.response
        );
    },
    setFeature(params) {
        return Axios.post(
            `${baseURL}account/enable-disable-feature`,
            params
        ).then(response => response.data.response);
    },
    getReleaseNotes(params) {
        return Axios.get(`${baseURL}account/release-note/`, { params }).then(
            response => response.data.response
        );
    },
    getDistributor(id) {
        return Axios.get(
            `${process.env.BARRAMUNDI}account/find-distibutor/${id}`
        ).then(res => {
            if (res && res.data.response && res.data.response.message) {
                return res.data.response.message.resources;
            }
            return null;
        });
    },
    getBusinessByEncodedId(encodedBusinessId) {
        return Axios.get(
            `${baseURL}account/business/view/${encodedBusinessId}`
        ).then(response => response.data.response);
    },
    enableAddOn(params) {
        return Axios.post(`${baseURL}account/add-on/enable`, params).then(
            response => response.data.response
        );
    },
    async checkOnboardAccount(businessId) {
        try {
            const response = await Axios.get(
                `${baseURL}payment/onboard/checkAccount/${businessId}`
            );
            return response.data?.response ?? null;
        } catch (error) {
            console.error("Failed to call checkAccount:", error);
            return null;
        }
    },
    getPreQualSetting(businessId) {
        return Axios.get(
            `${baseURL}account/business/payment/pqlinksetting/${businessId}/0`
        ).then(response => response.data.response);
    },
    setPreQualSetting(params) {
        return Axios.post(
            `${baseURL}account/business/payment/pqlinksetting`,
            params
        ).then(response => response.data.response);
    },
    /**
     * Attempt to get redirect URL using secret
     * @param {String} secret
     * @returns {String|null}
     */
    async getLoginRedirectFromSecret(secret) {
        try {
            const res = await Axios.post(`${baseURL}account/update-password`, {
                secret,
                password: "" // intentionally blank to simulate check
            });

            const redirect = res?.data?.response?.redirect;
            return redirect || null;
        } catch (error) {
            console.warn(
                "getLoginRedirectFromSecret failed:",
                error?.response?.data
            );
            return null;
        }
    }
};
